/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-13 17:50:14
 * @LastEditTime: 2019-08-13 18:06:51
 * @LastEditors: Please set LastEditors
 */
import React, { Component } from 'react';

export default class Page extends Component {

  constructor(props) {
    super(props);

    this.state = {

    }
  }

  render() {

    return (
      <React.Fragment>
        <h4 className="t1"></h4>

        <div className="rule-content">
          <div className="text">
            <strong>1.活动时间：</strong>
            <p>（1）预约送水时间：2019年9月18日00：00——2019年9月24日23：59</p>
            <p>（2）实时领券时间：2019年9月25日00：00——2019年10月8日23：59</p>
            <strong>2.活动规则：</strong>
            <p>（1）用户在9月25日——10月8日期间，存在通过12306同步的本人高铁行程，即满足免费送水条件；</p>
            <p>（2）满足免费送水条件的用户，可在9月18日——9月24日之间，选择一趟本人行程按步骤操作预约送水，矿泉水预约成功后将在用户上车后半小时内送达座位；</p>
            <p>（3）如用户未在9月18日——9月24日操作预约送水，在9月25日——10月8日可领取掌上高铁app送出的5元无门槛“免费饮水券”1张，高铁订餐通用（餐车自营无需配送费），用户可在行程中自行下单商品（最低支付0.01元），该券在10月10日前有效。</p>
            <strong>3.免责申明：</strong>
            <p>（1）由于部分车次暂未开通高铁送餐，或部分车次矿泉水品类商品售罄，或用户的旅途时间过短（乘车时长短于半小时）等客观原因造成的送水失败，掌上高铁不承担任何责任。</p>
            <p>（2）针对以上因客观原因造成送水失败的情况，掌上高铁出于对用户的关怀，将送出“免费饮水券”1张，用户可自行使用。</p>
            <p>（3）法律允许的范围内，本次活动的最终解释权归国铁吉讯科技有限公司所有。</p>
          </div>
        </div>
      </React.Fragment>
     )
  }
}
